import React from "react";
import { Link } from "react-router-dom";
import { RiShoppingCart2Fill } from "react-icons/ri";
import { MdSwitchAccount } from "react-icons/md";
import { useSelector } from "react-redux";
import { BsWhatsapp } from "react-icons/bs";

const SpecialCase = () => {
  const products = useSelector((state) => state.orebiReducer.products);
  return (
    <div className="fixed bottom-0 right-2 z-20 flex flex-row gap-2">
     
      <Link to="https://wa.me/+919080857464">
  <div style={{ backgroundColor: '#25D366' }} className="w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
    <div className="flex justify-center items-center">
      <BsWhatsapp className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />
      <BsWhatsapp className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
    </div>
    <p className="text-xs font-semibold font-titleFont">Whatsapp</p>
  </div>
</Link>
    </div>
  );
};

export default SpecialCase;
